import styled from 'styled-components';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import _ from 'lodash';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { ReturnExchangesApi } from '../../../../../../../apis/ReturnExchangesApi';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .returnExchangeTypeButton{
    height: 30px;
    padding: 0 10px;
    border-radius: 3px;
    border:none;
    font-size: 12px;
    font-weight: 600;

    &.return{
        background-color: #f5b1b1;
        color: #fff;
    }

    &.exchange{
        background-color: #b1d4f5;
        color: #fff;
    }
  }
`

export function TdReturnExchangeType({
    returnExchange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const handleChangeType = async () => {
        const editableData = _.cloneDeep(returnExchange);

        switch (editableData?.returnExchangeType) {
            case 'RETURN':
                editableData.returnExchangeType = 'EXCHANGE';
                break;
            case 'EXCHANGE':
                editableData.returnExchangeType = 'RETURN';
                break;
            default:
                break;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().updateList({
            headers: headers,
            body: {
                updateEventType: 'SWAP_RETURN_EXCHANGE',
                returnExchanges: [editableData]
            }
        });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
        }
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <StyledTableCell>
                <ReturnExchangeTypeButton
                    returnExchangeType={returnExchange?.returnExchangeType}
                    onChangeType={handleChangeType}
                />
            </StyledTableCell>
        </>
    );
}

function ReturnExchangeTypeButton({
    returnExchangeType,
    onChangeType
}) {
    switch (returnExchangeType) {
        case 'RETURN':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeTypeButton return`}
                    onClick={(e) => { e.stopPropagation(); onChangeType(); }}
                >
                    반품
                </CustomBlockButton>
            );
        case 'EXCHANGE':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeTypeButton exchange`}
                    onClick={(e) => { e.stopPropagation(); onChangeType(); }}
                >
                    교환
                </CustomBlockButton>
            );
        default:
            return '';
    }
}